import React, { useState } from 'react';
import { ApiClient } from '../../../api/ApiClient';
import { v2 } from '../../../api/ApiInterfaceV2';
import { JiraProjectData } from '../../../api/endpoints/jira';
import { useLoader2 } from '../../../platform/Hook';
import { Grid, Input } from '../../../ui';
import { LoadingGuard } from '../../../ui/LoadingGuard';
import { FlexScroller } from '../../../ui/Scrollers';
import { useResolve } from '../../Container';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { JiraProject, JiraProjectSelectableFrame } from './JiraProject';

const JiraProjectItem = ({ item }: { item: JiraProjectData }) => {
    return <JiraProject>
        <JiraProject.Left>
            <JiraProject.Icon src={item.avatarUrls['48x48']} />
        </JiraProject.Left>
        <JiraProject.Main>
            <JiraProject.Title>{item.name}</JiraProject.Title>
            <JiraProject.Info>({item?.insight?.totalIssueCount} issues)</JiraProject.Info>
        </JiraProject.Main>
    </JiraProject>;
};

export const SelectJiraProjectView = ({ onSelect }: { onSelect(project: JiraProjectData): void }) => {

    const api = useResolve(ApiClient);
    const [query, setQuery] = useState('' as string);

    const [loading, results] = useLoader2(() => api.exec(v2.jira.projects.list(query)), [query]);

    return <Flexer grow flex="column" gap="1">
        <Flexer shrink>
            <Input placeholder="Search Projects" value={query} onChange={setQuery} />
        </Flexer>
        <LoadingGuard loading={loading}>
            {!!results &&
                <FlexScroller>
                    <Flexer padding=".5">
                        <Grid columns="1fr 1fr 1fr" columnGap="1" rowGap="1">
                            {results.values.map(x =>
                                <JiraProjectSelectableFrame key={x.id} onClick={() => onSelect(x)}>
                                    <JiraProjectItem item={x} />
                                </JiraProjectSelectableFrame>
                            )}
                        </Grid>
                    </Flexer>
                </FlexScroller>
            }
        </LoadingGuard>
    </Flexer>;
};
